const E164_MAX_DIGITS = 15;
const CUSTOMER_PHONE_MAX_LENGTH = 15;

function formatNanpDigits(digits: string): string {
  if (digits.length < 4) {
    return digits;
  }
  if (digits.length < 7) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  }
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
}

/**
 * Formats contract phone input using the same proposed behavior as the Showroom lead-capture form.
 */
export function formatContractPhoneNumber(value: string): string {
  if (!value) {
    return value;
  }

  const hasPlus = value.trimStart().startsWith("+");
  const digits = value.replace(/[^\d]/g, "").slice(0, E164_MAX_DIGITS);

  if (hasPlus) {
    if (digits.length === 0) {
      return "+";
    }
    if (digits.startsWith("1") && digits.length === 11) {
      return formatNanpDigits(digits.slice(1));
    }
    if (digits.startsWith("1") && digits.length < 11) {
      return `+1 ${formatNanpDigits(digits.slice(1))}`.trimEnd();
    }
    return `+${digits}`;
  }

  if (digits.length === 11 && digits.startsWith("1")) {
    return formatNanpDigits(digits.slice(1));
  }
  if (digits.length > 10) {
    return `+${digits}`;
  }
  return formatNanpDigits(digits);
}

/**
 * Validates optional contract phone input using E.164 digit bounds while allowing common separators.
 */
export function validateContractPhoneNumber(value: string): string | null {
  if (!value.trim()) {
    return null;
  }

  const compact = value.replace(/[\s().-]/g, "");
  const digitCount = (value.match(/\d/g) ?? []).length;
  if (!/^\+?\d+$/.test(compact) || digitCount < 10 || digitCount > E164_MAX_DIGITS) {
    return "Invalid phone number.";
  }
  if (value.length > CUSTOMER_PHONE_MAX_LENGTH) {
    return `Phone number must be ${CUSTOMER_PHONE_MAX_LENGTH} characters or fewer.`;
  }

  return null;
}
